/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Chip } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Unstable_Grid2';
import CloseIcon from '@mui/icons-material/Close';
import CircleIcon from '@mui/icons-material/Circle';

export default function CoverageModal({ coverageDtls, setCoverageDtls }) {
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const openInNewTab = (url) => {
    // Open the URL in a new tab/window and add security features
    const newTab = window.open(url, '_blank', 'noopener,noreferrer');
    if (newTab) {
      newTab.focus(); // Attempt to focus the new tab
    }
  };

  const statusColumn =
    coverageDtls?.title === 'Coverage'
      ? [
          {
            field: 'status',
            headerName: 'Status',
            width: 200,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => <div dangerouslySetInnerHTML={{ __html: params.row.status }} />,
          },
        ]
      : [];

  const rbaColumn =
    !coverageDtls?.title?.includes('RBA') && coverageDtls?.title !== 'Coverage'
      ? [
          {
            field: 'marketing',
            headerName: 'Purpose',
            width: 200,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
              params?.row?.materials?.map((row) => (
                <Chip
                  label={row?.name}
                  variant='outlined'
                  onClick={() => openInNewTab(row?.link)}
                />
              ));
            },
          },
        ]
      : [];

  const marketingColumn =
    coverageDtls?.title?.includes('RBA') && coverageDtls?.title !== 'Coverage'
      ? [
          {
            field: 'purpose',
            headerName: 'Purpose',
            width: 200,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
              const notes = params?.row?.note;
              const arr = notes
                .split(';')
                .map((item) => item.trim())
                .filter(Boolean);

              return arr[0] ?? '';
            },
          },
          {
            field: 'actual',
            headerName: 'Actual',
            width: 200,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
              const notes = params?.row?.note;
              const arr = notes
                .split(';')
                .map((item) => item.trim())
                .filter(Boolean);

              return arr[1] ?? '';
            },
          },
        ]
      : [];

  const columns = [
    {
      field: 'date_scheduled',
      headerName: 'Appointment Date',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'date_completed',
      headerName: 'Date Completed',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    ...statusColumn,
    {
      field: 'planned',
      headerName: 'Planned Agenda',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'accomplished',
      headerName: 'Accomplished Agenda',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    ...rbaColumn,
    ...marketingColumn,
  ];

  const handleClose = () => {
    setCoverageDtls({ ...coverageDtls, loading: false, toggle: false, title: null, details: [] });
  };
  return (
    <Dialog open={coverageDtls?.toggle} onClose={handleClose} maxWidth='xl' fullWidth>
      <DialogTitle>
        {coverageDtls?.title}{' '}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container>
          {coverageDtls?.title === 'Coverage' ? (
            <Grid item md={12}>
              <Stack alignItems='center' direction='row' gap={2}>
                <CircleIcon sx={{ color: '#6b8d3e' }} />
                Planned
                <CircleIcon sx={{ color: '#a82716' }} />
                Missed
                <CircleIcon sx={{ color: '#1f46f5' }} />
                Advanced
                <CircleIcon sx={{ color: '#ffe600' }} />
                Retrieved
              </Stack>
            </Grid>
          ) : (
            ''
          )}
          <Grid item md={12} mt={2}>
            <Box
              className='table-container'
              sx={{
                height: `800px`,
                '& .super-app-theme--header': {
                  fontWeight: 'bold',
                  backgroundColor: '#6B8D3E',
                  color: '#fff',
                },
              }}
            >
              <DataGridPro
                loading={coverageDtls.loading}
                rows={coverageDtls.details}
                columns={columns}
                sortModel={sortModel}
                initialState={{
                  ...coverageDtls.details,
                  pagination: {
                    pageSize: 50,
                  },
                }}
                getRowId={(row) => row.appointment_id}
                rowsPerPageOptions={[25, 50, 100]}
                pagination
                onSortModelChange={(model) => setSortModel(model)}
                getRowClassName={(params) => {
                  return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
